import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';

import axios from 'axios';
import Moment from 'moment';

class Blogsidebar extends Component {
    constructor() {
        super();
       this.state = { 
        blogData:[],
        tagpost:[{tag : "deneme"}]
 }
}

   async componentDidMount() {
       await this._getBlogCategory()
   }


   _getBlogCategory = async () => {
    try{
    await axios.get(`https://buharaapi.stechomeyazilim.info:5210/getBlogCategory/select/`)
     .then(res => {
         this.setState({blogData: res.data })})
   }
   catch (error) {
     
     console.log("errorAS" + error)
   }
}

    render() {
        return (
            <Fragment>
                <div className="main-box padding-20 side-blog mb-xl-20">
                    <h4 className="text-light-black font-['Title'] text-[24px] m-2">Popüler Bloglar</h4>
                    {this.props._blogData.slice(0,4).map((item, i) => (
                        <article key={i} className="side-post pb-xl-20 mb-xl-20 u-line">
                            <div className="thumb-img">
                                <Link  to={"/blog-detay/"  + (item.Blog_Title).replace('?', '').replace(/\s+/g, '-')} state={{ID: item.ID, _item:item}}>
                                    <img src={'https://buharasubdomain.stechomeyazilim.info/' + item.Blog_Image} alt="thumb" />
                                </Link>
                            </div>
                            <div className="content-wrap">
                                <div className="entry-meta-content">
                                    <h5 className="entry-title">
                                        <Link  to={"/blog-detay/"  + (item.Blog_Title).replace('?', '').replace(/\s+/g, '-')} state={{ID: item.ID, _item:item}} className="text-light-black">{item.Blog_Title}</Link>
                                    </h5>
                                    <div className="entry-tye"> <span className="text-light-green fw-600">{Moment(item.Created_DateTime).fromNow()}</span>
                                    </div>
                                </div>
                            </div>
                        </article>
                    ))}
                </div>
                <div className="main-box padding-20 blog-tags mb-xl-20">
                    <h4 className="text-light-black">Anahtar Kelimeler</h4>
                    {this.state.tagpost.map((item, i) => (
                        <Link to="/blog-details" key={i}>#{item.tag}</Link>
                    ))}
                </div>
                <div className="main-box padding-20 trending-blog-cat mb-xl-20">
                    <h4 className="text-light-black">Kategori</h4>
                    <ul>
                        {this.state.blogData.slice(0, 4).map((item, i) => (
                            <li key={i} className="pb-xl-20 u-line mb-xl-20">
                                <Link to="/blog-details" className="text-light-black fw-600">
                                    {item.Blog_Category_Title}
                                    <span className="text-light-white fw-400">({item.Blog.length})</span></Link>
                            </li>
                        ))}
                    </ul>
                </div>
               
            </Fragment>
        );
    }
}

export default Blogsidebar;